interface HeadMeta {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogUrl: string;
  type: 'website' | 'article';
  locale: string;
}

function upsertMeta(attr: 'name' | 'property', key: string, content: string): void {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertCanonical(href: string): void {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

/**
 * Applies route-aware metadata to <head>. Reuses existing tags and creates
 * missing ones, keeping exactly one managed tag per name/property/rel.
 */
export function applyHead(meta: HeadMeta): void {
  document.title = meta.title;

  upsertMeta('name', 'description', meta.description);
  upsertMeta('name', 'keywords', meta.keywords);

  upsertMeta('property', 'og:title', meta.title);
  upsertMeta('property', 'og:description', meta.description);
  upsertMeta('property', 'og:url', meta.ogUrl);
  upsertMeta('property', 'og:type', meta.type);
  upsertMeta('property', 'og:locale', meta.locale);

  upsertMeta('name', 'twitter:card', 'summary_large_image');
  upsertMeta('name', 'twitter:title', meta.title);
  upsertMeta('name', 'twitter:description', meta.description);

  upsertCanonical(meta.canonicalUrl);
}